import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminHeader, RoleProtectedRoute } from '../../../shared/components';
import { useRoles } from '../../../shared/hooks';
import NotificationsList from './NotificationsList';

/**
 * Pantalla de monitoreo de mensajes de WhatsApp.
 * Solo para administradores: el endpoint usa AdminRoleGuard.
 */
const NotificationsManagement = ({ adminData, onLogout }) => {
  const navigate = useNavigate();
  const { ROLES } = useRoles();

  return (
    <RoleProtectedRoute requiredRoles={[ROLES.ADMIN]}>
      <div className="min-h-screen bg-gray-50">
        <AdminHeader
          adminData={adminData}
          onLogout={onLogout}
          showBackButton={true}
          onBackClick={() => navigate('/admin')}
          backButtonText="Volver al Dashboard"
        />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <NotificationsList />
        </main>
      </div>
    </RoleProtectedRoute>
  );
};

export default NotificationsManagement;
